import TopTickerBar from "./components/TopTickerBar";
import SiteHeader from "./components/SiteHeader";
import HeroLead from "./components/HeroLead";
import LiveFeedSection from "./components/LiveFeedSection";
import TopicWallSection from "./components/TopicWallSection";
import AnalysisSection from "./components/AnalysisSection";
import TimelineSection from "./components/TimelineSection";
import DeepDiveSection from "./components/DeepDiveSection";
import DiscussionSection from "./components/DiscussionSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopTickerBar />
      <SiteHeader />

      <main className="flex-1">
        <HeroLead />
        <LiveFeedSection />
        <TopicWallSection />
        <AnalysisSection />
        <TimelineSection />
        <DeepDiveSection />
        <DiscussionSection />
      </main>

      <SiteFooter />
    </div>
  );
}